import { useEffect, useState } from 'react';
import { getCurrencySettings } from '@/api/automaticCurrencyConversion';
import { airTracker } from '@/utils/airTracker';
import { CurrencyItem } from '@/types/automaticCurrencyConversion';
import { COMPONENT_NAME } from '@/pages/Main';

export const useCurrencySetting = (
  enabledPa: boolean,
  clientSecret?: string
): { accCurrencyList: string[]; loading: boolean } => {
  const [loading, setLoading] = useState(true);
  const [accCurrencyList, setAccCurrencyList] = useState<string[]>([]);

  useEffect(() => {
    if (clientSecret && enabledPa) {
      setLoading(true);
      const fetchCurrencySettings = async (): Promise<void> => {
        try {
          const data = await getCurrencySettings(clientSecret);
          const currenciesList = data?.items
            .filter((currencyItem: CurrencyItem) => currencyItem.type === 'currency_switcher')
            .map((currencyItem: CurrencyItem) => currencyItem.currencies)
            .reduce((accumulator, currentValue) => accumulator.concat(currentValue), []);
          const uniqCurrenciesList = Array.from(new Set(currenciesList));
          setAccCurrencyList(uniqCurrenciesList);
          airTracker.info('fetchCurrencySettingsSuccess', {
            component: COMPONENT_NAME,
            accCurrencyList: uniqCurrenciesList,
          });
          setLoading(false);
        } catch (error) {
          airTracker.error('apiError', { api: 'getCurrencySettings', error });
          setLoading(false);
        }
      };
      fetchCurrencySettings();
    } else {
      setLoading(false);
    }
  }, [clientSecret, enabledPa]);

  return { accCurrencyList, loading };
};
